import { PureConnect, React } from '../../react';
import { DateTimeText } from '../../shared/date';
// import Tooltip from '../../tooltip';
import { IBookmark, ICategory, INote, isNote, INoteShared, IParticipant, IUsergroup, isSharedNote, IQuestion, isQuestion, IQuestionDB } from '../../types';
import { bookmarksResource } from '../bookmarks/resource';
import adminReselectors from '../admin/reselectors';
// import { notesResource } from '../notes/resource';
import ADMIN_HIDE from './actions/HIDE';
import HOVER_ITEM from './actions/HOVER';
import { selectors as metaSelectors } from '../../meta/selectors';
import cx from './noteblock.less';
import windowSelectors from '../../window/selectors';
import NOTES_ITEM_LAST_TOUCHED from '../notes/actions/NOTES_ITEM_LAST_TOUCHED';
import { participantsResource } from '../../participant/resource';
import { usergroupResource } from '../../usergroup/resource';
import { notechatResource } from '../notechat/resource';
import { notesSharedResource } from '../noteshared/resource';
import { notesResource } from '../notes/resource';
import MenuButton from '../../react-toolbox/menuButton';
import { questionsResource } from '../question/resource';
import { beheerResource } from '../../admin/resource';
import { canChangeQuestion, factionOfNote, showFaction, statusNieuw, statusses } from '../question/authmodule/authcheck';

interface NoteblockProps {
    item: INote | IBookmark | INoteShared | IQuestion;
    itemno?: number;
    categories: ICategory[];
    onSelect: any;
    selected: boolean;
    onDelete: any;
    onEdit: any;
    onInspect: any;
    disableDelete: boolean;
}

interface NoteblockSharedProps {
    item: INote | IBookmark | INoteShared | IQuestion;
    itemno?: number;
    categories: ICategory[];
    onSelect: any;
    selected: boolean;
    onDelete: any;
    onEdit: any;
    onInspect: any;
    disableDelete: boolean;
}

const maxStatus =6;

function GetStatusString(status?: number) {
    const statusses = [
        { id: 1, name: 'Nieuw' },
        { id: 2, name: 'Behandelen' },
        { id: 3, name: 'In behandeling' },
        { id: 4, name: 'Klaar voor publiceren' },
        { id: 5, name: 'Gepubliceerd' },
        { id: 6, name: 'Gearchiveerd' },                        
    ];
    if (!status || !statusses || status===undefined || (status<1 && status>maxStatus))
        return '';
    return statusses[status - 1].name;
}

export const NoteblockItem = PureConnect<NoteblockProps|NoteblockSharedProps|any>(`NoteblockItem`)(
    (state) => ({
        docName: metaSelectors.docName(state),
        screenSmall: windowSelectors.small(state),  
        participants: adminReselectors.participantsSelector(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup), 
        hoveredId : state.admin.hoveredId,
        showlist: !!state.admin.listpresentation,
        allChats: notechatResource.selectors.items(state),
        allParticipants: adminReselectors.participantsSelector(state),
        allQuestions: questionsResource.selectors.items(state),
    }),
    (dispatch) => ({
        doReadBookmark: (item: IBookmark) => dispatch(bookmarksResource.actions.READ({ item })),
        doReadNote: (item: INote) => dispatch(NOTES_ITEM_LAST_TOUCHED({item: item})), 
        hideAdmin: () => dispatch(ADMIN_HIDE({ })),
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({ key, item, itemno, disableDelete, categories, onSelect, onExpand, onInspect, selected, expanded, onDelete, 
        onEdit, participants, allQuestions, showlist }) => {
        
        var shared = (!!isSharedNote(item));
        var keyval = isSharedNote(item) ? notesSharedResource.fields.key(item as INoteShared): notesResource.fields.key(item as INote);
        var canexpand = isQuestion(item) && allQuestions.qWhere((x: IQuestionDB)=>!!x.parentId).map((d: IQuestionDB) =>d.parentId).qAny((c: number) => c === item.id);

        if (item.isquestion) {                                                               
            const note: INote=item;
            return <ListNoteblock
                key={keyval}
                categories={categories}
                item={note}
                itemno={itemno}
                canexpand={canexpand}
                selected={selected}
                expanded={expanded}
                onSelect={onSelect}
                onExpand={onExpand}
                onEdit={onEdit}
                onDelete={onDelete} 
                onInspect={onInspect}  
                disableDelete = {disableDelete}                                                    
            />;
              
        } else if (shared && !showlist) {                                                                
            const note: INoteShared=item;                                                                
            return <NoteblockShared                                                            
                key={keyval}
                item={note}
                participants={participants}
                selected={selected}
                onSelect={onSelect}
                onInspect={onInspect}
            />;
        } else if (shared && showlist) {  
            const note: INoteShared=item; 
            return <ListNoteblockShared                                                           
                key={keyval}
                item={note}
                participants={participants}
                canexpand={canexpand}
                selected={selected}
                expanded={expanded}
                onSelect={onSelect}
                onExpand={onExpand}
                onInspect={onInspect}
            />;
        } else if (!shared && !showlist) {                                                                 
            const note: INote=item;
            return <Noteblock
                key={keyval}
                categories={categories}
                item={note}
                itemno={itemno}
                selected={selected}                
                onSelect={onSelect}
                onEdit={onEdit}
                onDelete={onDelete} 
                onInspect={onInspect}  
                disableDelete = {disableDelete}                                                    
            />;
        } else if (!shared && showlist) {                                                                 
            const note: INote=item;
            return <ListNoteblock
                key={keyval}
                categories={categories}
                item={note}
                itemno={itemno}
                canexpand={canexpand}
                selected={selected}
                expanded={expanded}
                onSelect={onSelect}
                onExpand={onExpand}
                onEdit={onEdit}
                onDelete={onDelete} 
                onInspect={onInspect}  
                disableDelete = {disableDelete}                                                    
            />;
        }    
    
});

export const ListNoteblock = PureConnect<NoteblockProps|NoteblockSharedProps|any>(`ListNoteblock`) (
    (state) => ({
        docName: metaSelectors.docName(state),
        screenSmall: windowSelectors.small(state),  
        participants: adminReselectors.participantsSelector(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup), 
        hoveredId : state.admin.hoveredId,
        allChats: notechatResource.selectors.items(state),
        allParticipants: adminReselectors.participantsSelector(state),
        allQuestions: questionsResource.selectors.items(state),
        beheer: beheerResource.selectors.items(state),
    }),
    (dispatch) => ({
        doReadBookmark: (item: IBookmark) => dispatch(bookmarksResource.actions.READ({ item })),
        doReadNote: (item: INote|INoteShared) => dispatch(NOTES_ITEM_LAST_TOUCHED({item: item})), 
        hideAdmin: () => dispatch(ADMIN_HIDE({ })),
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({  item, disableDelete, hoverItem, allQuestions, beheer, hoverItemOut, onSelect, onExpand, expanded, canexpand, onInspect, selected, onDelete, onEdit, participants, allparticipants, allparticipantsgroups, hideAdmin, doReadNote, doReadBookmark }) => {
        const open = () => {
            hideAdmin();
            if (isNote(item)) {
                hoverItemOut();
                doReadNote(item);                
            } else {
                doReadBookmark(item);
            }
        };

        const expandClick = (evt: any, item: INote) => {
            evt.preventDefault(); 
            return onExpand(item);
        };   

        const participant = isNote(item) && participants.qWhere((i: IParticipant)=>i.id===item.userId).qFirst();

        var hasparent = false;
        var haschevron = false;
        var nocheckbox = false;  
        var itemQuestion = null;
        var status= statusNieuw;
        if (item.isquestion) {
            itemQuestion = allQuestions.qFirst((o: IQuestionDB) => o.noteId === item.id) as IQuestionDB;
            if (itemQuestion) {      
                status = itemQuestion.status ? itemQuestion.status: statusNieuw;
                hasparent = !!itemQuestion.parentId;
                haschevron = item.isquestion && canexpand;
                nocheckbox = hasparent;                
            }            
        }
        
        const currentUser =  allparticipants.qWhere((i: IParticipant) =>i.isUser).qFirst();
        const currentUserId =  currentUser ? currentUser.id: ''; 
        var admin = beheer && beheer.qAny() && beheer.qFirst();

        return (
            <div className={cx('container-list' , selected ? 'selected' : '')} onMouseEnter={() =>hoverItem(item.id)} onMouseLeave={() => hoverItemOut()}>
                <div className={cx('content-container-list')}>
                    { haschevron  ?
                    <button 
                        key={'chevron' + item.id}
                        className={cx('btn', 'icon-btn', expanded ? 'chevron_up': 'chevron_down')} 
                        aria-label={`Openklappen`}                  
                        tabIndex={0} 
                        onClick={(evt: any) => expandClick(evt, item)}>
                        <span aria-hidden="true" className={cx('chevron', expanded ? 'icon-chevron_up' : 'icon-chevron_down')}></span>
                    </button> : null
                    }
                    { nocheckbox ? null :
                        <div className={cx('default-checkbox-div', 'check-box-selection')} 
                            key={item.id}
                            tabIndex={-1}>
                            <input type="checkbox" 
                                className={cx('default-checkbox')} 
                                tabIndex={-1}  
                                checked={selected}
                                onChange={() => onSelect(item)}
                                aria-hidden={true}/>
                            <div role="checkbox" 
                                className={cx('checkmark')}
                                aria-checked={selected ? 'true': 'false'}
                                
                                tabIndex={0}
                                onKeyPress={(ev: any)=> { if (ev.key==='Enter') { onSelect(item);}}}
                                onClick={() => onSelect(item)}>
                            </div> 
                        </div>
                    }
                    <div id={`id-ref-${item.id}`} className={cx('text-list')} onClick={() => onInspect(item)}>
                        <div className={cx('text-list-container')}>
                            <span>{isNote(item) ? item.text : item.name}</span>
                        </div>
                    </div>
                    <div className={cx('autho-name-list')} onClick={() => onInspect(item)}><span className={cx('autho-name-list-text')}>{participant?participant.name : ''}</span></div>
                    <div className={cx('faction-name-list')} onClick={() => onInspect(item)}>
                        <span className={cx('faction-name-list-text')}>
                            {isQuestion(item) && showFaction(status, item.userId, currentUserId, allparticipantsgroups)? factionOfNote(item, allparticipantsgroups): ''}
                        </span>
                    </div>
                    <div id={`id-ref-${item.id}`} className={cx('created-list')} onClick={() => onInspect(item)}>
                        <span className={cx('created-list-text')}><DateTimeText date={item.created} /></span>
                    </div>   
                    {item.isquestion ?
                    <div id={`id-ref-${item.id}`} className={cx('status-list', 'status'+ (status).toString())} onClick={() => onInspect(item)}>
                        <span className={cx('status-list-text')}>{GetStatusString(status)}</span>
                    </div> :null
                    }
                    <div className={cx('list-note-btn')}>
                        <MenuButton className="list-item-menu-btn">  
                            <div className={cx('list-button-area')}>                                                                                                                                                                    
                                <span className={cx('icon-goto')} title="naar publicatie" onClick={() => open()}></span>
                                <span className={cx('icon-show')} title="bekijk" onClick={() => onInspect(item)}></span>
                                {itemQuestion && canChangeQuestion(statusses, status, currentUserId, allparticipantsgroups, admin) || !itemQuestion ? <span className={cx('icon-edit')} title="bewerk" onClick={() => onEdit(item)}></span>:null}
                                {disableDelete ? null: <span className={cx('icon-delete')} title="verwijderen" onClick={() => onDelete(item)}></span>}
                            </div>                                                      
                        </MenuButton>
                    </div>
                </div>
            </div>
        );
});

export const Noteblock = PureConnect<NoteblockProps|NoteblockSharedProps|any>(`Noteblock`) (
    (state) => ({
        docName: metaSelectors.docName(state),
        screenSmall: windowSelectors.small(state),  
        participants: adminReselectors.participantsSelector(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup), 
        hoveredId : state.admin.hoveredId,
        allChats: notechatResource.selectors.items(state),
        allParticipants: adminReselectors.participantsSelector(state),
    }),
    (dispatch) => ({
        doReadBookmark: (item: IBookmark) => dispatch(bookmarksResource.actions.READ({ item })),
        doReadNote: (item: |INoteShared) => dispatch(NOTES_ITEM_LAST_TOUCHED({item: item})), 
        hideAdmin: () => dispatch(ADMIN_HIDE({ })),
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({  item, disableDelete, categories, hoverItem, hoveredId, hoverItemOut, onSelect, onInspect, selected, onDelete, onEdit, participants, allparticipants, allparticipantsgroups, hideAdmin, doReadNote, doReadBookmark }) => {

        const open = () => {
            hideAdmin();
            if (isNote(item) || isSharedNote(item)) {
                doReadNote(item);
            } else {
                doReadBookmark(item);
            }
        };

        const color = categories ? categories.reduce((catColor: string, category: ICategory) => {
            catColor = (item.categoryId === category.id) ? category.color : catColor;
            return catColor;
        }, '#efefef'): '#efefef';

        var categoryName;
        if (color === '#efefef') {            
            categoryName='geen';
        } else if (item && categories && categories.qWhere((itm: ICategory) => item.categoryId === itm.id)) {
            let category = categories.qWhere((itm: ICategory) => item.categoryId === itm.id).qFirst();       
            categoryName=category.name;
        }

        const participant = isNote(item) && participants.qWhere((i: IParticipant)=>i.id===item.userId).qFirst();
        
        return (
            <div className={cx('container', selected ? 'selected' : '')} onMouseEnter={() =>hoverItem(item.id)} onMouseLeave={() => hoverItemOut()}>
                <div className={cx('left-side-area')}>
                    <div className={cx('default-checkbox-div', 'check-box-selection')} 
                        key={item.id}
                        tabIndex={-1}>
                        <input type="checkbox" 
                            className={cx('default-checkbox')} 
                            tabIndex={-1}  
                            checked={selected}
                            onChange={() => onSelect(item)}
                            aria-hidden={true}/>
                        <div role="checkbox" 
                            className={cx('checkmark')}
                            aria-checked={selected ? 'true': 'false'}
                            
                            tabIndex={0}
                            onKeyPress={(ev: any)=> { if (ev.key==='Enter') { onSelect(item);}}}
                            onClick={() => onSelect(item)}>
                        </div> 
                    </div>
                </div>
                <div className={cx('content-container')}>
                    <div className={cx('header')}>                    
                        <div className={cx('contentheader')}>
                            <div className={cx('icon-left-container')}>
                                <span className={cx('icon-container', isNote(item) && item.isquestion? 'question' : 'message')}></span>
                            </div>
                            <div className={cx('icon-middle-first-container')}>
                                <div className={cx('text-container_author')}>
                                    <span className={cx('autho-container')}>Aangemaakt door</span>
                                    <span className={cx('autho-name')}>{participant?participant.name : ''}</span>
                                </div>
                                <div className={cx('container-shared-with')}>
                                    <span className={cx('shared-with-label')}>Gedeeld met</span>
                                    <div className={cx('icons-container')}>
                                        {isNote(item) && item&&item.noteParticipantsIDs&&item.noteParticipantsIDs.length?<span title={mapParticipantsNames(item.noteParticipantsIDs, allparticipants)} className={cx('icon-shared')}></span>: null}
                                        {isNote(item) && item&&item.noteParticipantsIDs&&item.noteParticipantsIDs.length?<span className={cx('shared-count')}>{participantsCount(item.noteParticipantsIDs, allparticipants)}</span>: null}
                                        {isNote(item) && item&&item.noteParticipantGroupIDs&&item.noteParticipantGroupIDs.length?<span title={mapGroups(item.noteParticipantGroupIDs, allparticipantsgroups)} className={cx('icon-shared_multiple')}></span> : null}
                                        {isNote(item) && item&&item.noteParticipantGroupIDs&&item.noteParticipantGroupIDs.length?<span className={cx('shared-groups-count')}>{groupsCount(item.noteParticipantGroupIDs, allparticipantsgroups)}</span>: null}                                
                                        {isNote(item) && !(item&&item.noteParticipantsIDs&&item.noteParticipantsIDs.length) &&
                                                        !(item&&item.noteParticipantGroupIDs&&item.noteParticipantGroupIDs.length)?
                                            <span className={cx('shared-to-no-one')}>Niet gedeeld</span>: null
                                        }
                                    </div>
                                </div>     
                                <div className={cx('container-category')}>
                                    <span className={cx('container-category-label')}>Categorie</span>
                                    <span className={cx('categorie-name')}><span className={cx('icon-container-category')} style={{backgroundColor:color}}></span>{categoryName}</span>
                                </div>                                                       
                            </div>
                        </div>                 
                    </div>
                    { hoveredId === item.id ? 
                        <div className={cx('right-side-area')}>
                            <span className={cx('icon-goto')} onClick={(() => open())}></span>
                            <span className={cx('icon-show')} onClick={() => onInspect(item)}></span>
                            <span className={cx('icon-edit')} onClick={() => onEdit(item)}></span>
                            {disableDelete ? null: <span className={cx('icon-delete')} onClick={() => onDelete(item)}></span>}
                        </div>
                        :null
                    }
                    <div className={cx('content')}>
                            <span id={`id-ref-${item.id}`} className={cx('created')}>{isNote(item) && item.isquestion? 'Technische vraag' : 'Notitie'} gemaakt op <DateTimeText date={item.created} /></span>
                            <p id={`id-ref-${item.id}`} className={cx('text')}>{isNote(item) ? item.text : item.name}</p>
                            <span className={cx('shadow-span')}></span>
                    </div>
                </div>
            </div>
        );
});

export const NoteblockShared = PureConnect<NoteblockSharedProps|NoteblockSharedProps|any>(`NoteblockShared`)(
    (state) => ({
        docName: metaSelectors.docName(state),
        screenSmall: windowSelectors.small(state),  
        participants: adminReselectors.participantsSelector(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup), 
        hoveredId : state.admin.hoveredId,
    }),
    (dispatch) => ({
        doReadBookmark: (item: IBookmark) => dispatch(bookmarksResource.actions.READ({ item })),
        doReadNote: (item: INote|INoteShared) => dispatch(NOTES_ITEM_LAST_TOUCHED({item: item})), 
        hideAdmin: () => dispatch(ADMIN_HIDE({ })),
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({ item, categories, hoverItem, hoveredId, hoverItemOut, onSelect, onInspect, selected,  participants, allparticipants, allparticipantsgroups, hideAdmin, doReadNote, doReadBookmark }) => {

        const open = () => {
            hideAdmin();
            if (isNote(item) || isSharedNote(item)) {
                doReadNote(item);
        }};

        const color = categories ? categories.reduce((catColor: string, category: ICategory) => {
            catColor = (item.categoryId === category.id) ? category.color : catColor;
            return catColor;
        }, '#efefef'): '#efefef';

        const participant = isNote(item) && participants.qWhere((i: IParticipant)=>i.id===item.userId).qFirst();
        // const hasError = isNote(item) ? notesResource.fields.error(item) : bookmarksResource.fields.error(item);
        return (
            <div className={cx('container', selected ? 'selected' : '')} onMouseEnter={() =>hoverItem(item.id)} onMouseLeave={() => hoverItemOut()}>
                <div className={cx('left-side-area')}>
                    <div className={cx('default-checkbox-div', 'check-box-selection')} 
                        key={item.id}
                        tabIndex={-1}>
                        <input type="checkbox" 
                            className={cx('default-checkbox')} 
                            tabIndex={-1}  
                            checked={selected}
                            onChange={() => onSelect(item)}
                            aria-hidden={true}/>
                        <div role="checkbox" 
                            className={cx('checkmark')}
                            aria-checked={selected ? 'true': 'false'}
                            
                            tabIndex={0}
                            onKeyPress={(ev: any)=> { if (ev.key==='Enter') { onSelect(item);}}}
                            onClick={() => onSelect(item)}>
                        </div> 
                    </div>
                </div>
                <div className={cx('content-container')}>
                    <div className={cx('header')}>                    
                        <div className={cx('contentheader')}>
                            <div className={cx('icon-left-container')}>
                                <span className={cx('icon-container', isNote(item) && item.isquestion? 'question' : 'message')}></span>
                            </div>
                            <div className={cx('icon-middle-first-container')}>
                                <div className={cx('text-container_author')}>
                                    <span className={cx('autho-container')}>Aangemaakt door</span>
                                    <span className={cx('autho-name')}>{participant?participant.name : ''}</span>
                                </div>
                                <div className={cx('container-shared-with')}>
                                    <span className={cx('shared-with-label')}>Gedeeld met</span>
                                    <div className={cx('icons-container')}>
                                        {isNote(item) && item&&item.noteParticipantsIDs&&item.noteParticipantsIDs.length?<span title={mapParticipantsNames(item.noteParticipantsIDs, allparticipants)} className={cx('icon-shared')}></span>: null}
                                        {isNote(item) && item&&item.noteParticipantsIDs&&item.noteParticipantsIDs.length?<span className={cx('shared-count')}>{participantsCount(item.noteParticipantsIDs, allparticipants)}</span>: null}
                                        {isNote(item) && item&&item.noteParticipantGroupIDs&&item.noteParticipantGroupIDs.length?<span title={mapGroups(item.noteParticipantGroupIDs, allparticipantsgroups)} className={cx('icon-shared_multiple')}></span> : null}
                                        {isNote(item) && item&&item.noteParticipantGroupIDs&&item.noteParticipantGroupIDs.length?<span className={cx('shared-groups-count')}>{groupsCount(item.noteParticipantGroupIDs, allparticipantsgroups)}</span>: null}                                
                                        {isNote(item) && !(item&&item.noteParticipantsIDs&&item.noteParticipantsIDs.length) &&
                                                        !(item&&item.noteParticipantGroupIDs&&item.noteParticipantGroupIDs.length)?
                                            <span className={cx('shared-to-no-one')}>Niet gedeeld</span>: null
                                        }
                                    </div>
                                </div>     
                                <div className={cx('container-category')}>
                                    <span className={cx('container-category-label')}>Categorie</span>
                                    <span className={cx('icon-container-category')} style={{backgroundColor:color}}></span>                            
                                </div>                                                       
                            </div>
                        </div>                 
                    </div>
                    { hoveredId === item.id ? 
                        <div className={cx('right-side-area')}>
                            <span className={cx('icon-goto')} onClick={() => open()}></span>
                            <span className={cx('icon-show')} onClick={() => onInspect(item)}></span>
                        </div>
                        :null
                    }
                    <div className={cx('content')}>
                            <span id={`id-ref-${item.id}`} className={cx('created')}>{isNote(item) && item.isquestion? 'Technische vraag' : 'Notitie'} gemaakt op <DateTimeText date={item.created} /></span>
                            <p id={`id-ref-${item.id}`} className={cx('text')}>{isNote(item) ? item.text : item.name}</p>
                            <span className={cx('shadow-span')}></span>
                    </div>
                </div>
            </div>
        );

});

export const ListNoteblockShared = PureConnect<NoteblockSharedProps|NoteblockSharedProps|any>(`ListNoteblockShared`)(
    (state) => ({
        docName: metaSelectors.docName(state),
        screenSmall: windowSelectors.small(state),  
        participants: adminReselectors.participantsSelector(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup), 
        hoveredId : state.admin.hoveredId,
        allQuestions: questionsResource.selectors.items(state),
        beheer: beheerResource.selectors.items(state),
    }),
    (dispatch) => ({
        doReadBookmark: (item: IBookmark) => dispatch(bookmarksResource.actions.READ({ item })),
        doReadNote: (item: INote) => dispatch(NOTES_ITEM_LAST_TOUCHED({item: item})), 
        hideAdmin: () => dispatch(ADMIN_HIDE({ })),
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({ item, allQuestions, beheer, hoverItem, hoverItemOut, onSelect, onExpand, expanded, canexpand, selected,  participants, hideAdmin, onInspect, doReadNote, doReadBookmark }) => {
        const open = () => {
            hideAdmin();
            if (isNote(item) || isSharedNote(item)) {
                hoverItemOut();
                doReadNote(item);            
        }};

        const expandClick = (evt: any, item: INoteShared) => {
            evt.preventDefault(); 
            return onExpand(item);
        };   

        const participant = isNote(item) && participants.qWhere((i: IParticipant)=>i.id===item.userId).qFirst();

        var hasparent = false;
        var haschevron = false;
        var nocheckbox = false;
        var status= statusNieuw;        
        if (item.isquestion) {
            const itemQuestion = allQuestions.qFirst((o: IQuestionDB) => o.noteId === item.id) as IQuestionDB;
            if (itemQuestion) {        
                status = itemQuestion.status ? itemQuestion.status: statusNieuw;  
                // haschildren = allQuestions.qWhere((x: IQuestionDB)=>!!x.parentId).map((d: IQuestionDB) =>d.parentId).qAny((c: number) => c === itemQuestion.noteId);
                hasparent = !!itemQuestion.parentId;
                haschevron = item.isquestion && canexpand;
                nocheckbox = hasparent;
            }            
        }

        return (
            <div className={cx('container-list', selected ? 'selected' : '')} onMouseEnter={() =>hoverItem(item.id)} onMouseLeave={() => hoverItemOut()}>
                <div className={cx('content-container-list')}>
                    { haschevron  ?
                        <button 
                            key={'chevron' + item.id}
                            className={cx('btn', 'icon-btn', expanded ? 'chevron_up': 'chevron_down')} 
                            aria-label={`Openklappen`}                  
                            tabIndex={0} 
                            onClick={(evt: any) => expandClick(evt, item)}>
                            <span aria-hidden="true" className={cx(expanded ? 'icon-chevron_up' : 'icon-chevron_down')}></span>
                        </button> : null}
                    { nocheckbox ? null :                    
                        <div className={cx('default-checkbox-div', 'check-box-selection')} 
                            key={item.id}
                            tabIndex={-1}>
                            <input type="checkbox" 
                                className={cx('default-checkbox')} 
                                tabIndex={-1}  
                                checked={selected}
                                onChange={() => onSelect(item)}
                                aria-hidden={true}/>
                            <div role="checkbox" 
                                className={cx('checkmark')}
                                aria-checked={selected ? 'true': 'false'}
                                
                                tabIndex={0}
                                onKeyPress={(ev: any)=> { if (ev.key==='Enter') { onSelect(item);}}}
                                onClick={() => onSelect(item)}>
                            </div> 
                        </div>
                    }
                    <div id={`id-ref-${item.id}`} className={cx('text-list')}>
                        <div className={cx('text-list-container')}>
                            <span>{isNote(item) ? item.text : item.name}</span>
                        </div>
                    </div>
                    <div className={cx('autho-name-list')} onClick={() => onInspect(item)}><span className={cx('autho-name-list-text')}>{participant?participant.name : ''}</span></div>
                    <div className={cx('faction-name-list')} onClick={() => onInspect(item)}><span className={cx('faction-name-list-text')}></span></div>
                    <div id={`id-ref-${item.id}`} className={cx('created-list')} onClick={() => onInspect(item)}><span className={cx('created-list-text')}><DateTimeText date={item.created} /></span></div>    
                    {item.isquestion ?
                    <div id={`id-ref-${item.id}`} className={cx('status-list', 'status'+ (status).toString())} onClick={() => onInspect(item)}><span className={cx('status-list-text')}>{GetStatusString(status)}</span></div>:
                    null
                    }
                    
                    <div className={cx('list-note-btn')}>
                        <MenuButton className={cx('list-item-menu-btn')}>  
                            <div className={cx('list-button-area')}>                                                                                                                                                                    
                                <span className={cx('icon-goto')} title="naar publicatie" onClick={() => open()}></span>
                                <span className={cx('icon-show')} title="bekijk" onClick={() => onInspect(item)}></span>
                            </div>                                                      
                        </MenuButton>
                    </div>
                </div>
            </div>
        );

});

export const Bookmarkblock = PureConnect<NoteblockProps|any>(`Bookmarkblock`)(
    (state) => ({
        docName: metaSelectors.docName(state),
        screenSmall: windowSelectors.small(state),  
        participants: adminReselectors.participantsSelector(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup), 
        hoveredId : state.admin.hoveredId,
    }),
    (dispatch) => ({
        doReadBookmark: (item: IBookmark) => dispatch(bookmarksResource.actions.READ({ item })),
        hideAdmin: () => dispatch(ADMIN_HIDE({ })),
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({ item, categories, hoverItem, hoveredId, hoverItemOut, onSelect, selected, onDelete, onEdit, screenSmall, participants, allparticipants, allparticipantsgroups, hideAdmin, doReadNote, doReadBookmark, extraClassNames }) => {
        let bookmark: IBookmark=item;
        const open = () => {
            hideAdmin();
            doReadBookmark(item);            
        };

        // const hasError = isNote(item) ? notesResource.fields.error(item) : bookmarksResource.fields.error(item);
        return (
            <div className={cx('container', extraClassNames, selected ? 'selected' : '')} onMouseEnter={() =>hoverItem(item.id)} onMouseLeave={() => hoverItemOut()}>
                <div className={cx('left-side-area')}>
                    <div className={cx('default-checkbox-div', 'check-box-selection')} 
                        key={item.id}
                        tabIndex={-1}>
                        <input type="checkbox" 
                            className={cx('default-checkbox')} 
                            tabIndex={-1}  
                            checked={selected}
                            onChange={() => onSelect(item)}
                            aria-hidden={true}/>
                        <div role="checkbox" 
                            className={cx('checkmark')}
                            aria-checked={selected ? 'true': 'false'}
                            
                            tabIndex={0}
                            onKeyPress={(ev: any)=> { if (ev.key==='Enter') { onSelect(item);}}}
                            onClick={() => onSelect(item)}>
                        </div> 
                    </div>
                </div>
                <div className={cx('middle-container')}>
                    <div className={cx('icon-left-container')}>
                        <span className={cx('icon-container', 'bookmark')}></span>
                    </div>
                    <div className={cx('text-container')}>
                        <span className={cx('text-container-page')}>
                            {bookmark.name}
                        </span>
                        </div>                                                         
                </div>               
                { hoveredId === item.id ?
                    <div className={cx('right-side-area')}>
                        <span className={cx('icon-goto')} onClick={open}></span>
                        <span className={cx('icon-delete')} onClick={() => onDelete(item)}></span>
                    </div>
                    :null
                }
            </div>
        );
});

function mapParticipantsNames(participantIds: string[], allparticipants: IParticipant[]) {
    let participantstring='';

    const participants = allparticipants.qWhere((item) => participantIds ? participantIds.qIncludes(item.id):false);
    participantstring = participants && participants.qAny()? 
        `Gedeeld met ${participants.map((x) => {
            return x.name;
        }).join(', ')}`:        
        '';
    return participantstring;
}

function participantsCount(participantIds: string[], allparticipants: IParticipant[]) {
    const participants = allparticipants.qWhere((item) => participantIds ? participantIds.qIncludes(item.id):false);
    return participants&&participants.length;
}    
    
function mapGroups(emailParticipantGroupIds: string[], allparticipantgroups: IUsergroup[]) {
    let groupsstring='';
    const groups = allparticipantgroups.qWhere((item) => emailParticipantGroupIds ? emailParticipantGroupIds.qSelect((itm)=>parseInt(itm)).qIncludes(item.id):false);    
    groupsstring =  
    groups && groups.qAny() ?
        `Gedeeld met ${groups.map((x) => {
            return x.name;
        }).join(', ')}` : '';
    return groupsstring;
}

function groupsCount(emailParticipantGroupIds: string[], allparticipantgroups: IUsergroup[]) {
    const groups = allparticipantgroups.qWhere((item) => emailParticipantGroupIds ? emailParticipantGroupIds.qSelect((itm)=>parseInt(itm)).qIncludes(item.id):false);    
    return groups&&groups.length;
}    



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/admin/noteblock.tsx